"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductInventorySearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductInventorySearchResponse extends common_1.PaginatedResponse {
}
exports.ProductInventorySearchResponse = ProductInventorySearchResponse;
//# sourceMappingURL=product-inventory-search.response.js.map